import { render, staticRenderFns } from "./myshipmentPDF.vue?vue&type=template&id=0b608c48&"
import script from "./myshipmentPDF.vue?vue&type=script&lang=js&"
export * from "./myshipmentPDF.vue?vue&type=script&lang=js&"
import style0 from "./myshipmentPDF.vue?vue&type=style&index=0&id=0b608c48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports